/**
 * Shared leaflet.markercluster options.
 * `removeOutsideVisibleBounds: false` avoids map/cluster desync when clicking a cluster while zoom fits bounds.
 * @see https://github.com/Leaflet/Leaflet.markercluster
 */
export function markerClusterIconCreateFunction(cluster: any): unknown {
  const L = (window as any).L;
  const markers = typeof cluster?.getAllChildMarkers === 'function' ? cluster.getAllChildMarkers() : [];
  const hasMonitoring =
    Array.isArray(markers) &&
    markers.some((m: any) => !!(m?.options?.monitoring));
  const hasPlanFactMismatch =
    Array.isArray(markers) &&
    markers.some((m: any) => !!(m?.options?.planFactCropMismatch));
  const childCount = typeof cluster?.getChildCount === 'function' ? cluster.getChildCount() : 0;
  let sizeClass = 'marker-cluster-small';
  if (childCount >= 10 && childCount < 100) {
    sizeClass = 'marker-cluster-medium';
  } else if (childCount >= 100) {
    sizeClass = 'marker-cluster-large';
  }
  const monClass = hasMonitoring ? ' marker-cluster--split-monitoring' : '';
  const warnClass =
    !hasMonitoring && hasPlanFactMismatch ? ' marker-cluster--split-plan-warning' : '';
  return new L.DivIcon({
    html: '<div><span>' + childCount + '</span></div>',
    className: 'marker-cluster ' + sizeClass + monClass + warnClass,
    iconSize: L.point(40, 40)
  });
}

export const DEFAULT_MARKER_CLUSTER_OPTIONS: Record<string, unknown> = {
  showCoverageOnHover: false,
  zoomToBoundsOnClick: true,
  spiderfyOnMaxZoom: true,
  disableClusteringAtZoom: 18,
  /** Pixel radius: larger values merge visually close markers earlier (fields/season map at wider zoom levels). */
  maxClusterRadius: 40,
  chunkedLoading: true,
  removeOutsideVisibleBounds: false,
  iconCreateFunction: markerClusterIconCreateFunction
};
